export const isMobileDevice = (userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent): boolean => {
  const uaData =
    typeof navigator === 'undefined'
      ? undefined
      : (navigator as Navigator & { userAgentData?: { mobile: boolean } }).userAgentData;
  if (uaData?.mobile) return true;

  const maxTouchPoints = typeof navigator === 'undefined' ? 0 : navigator.maxTouchPoints;
  if (userAgent.includes('Macintosh') && maxTouchPoints > 1) return true;

  const hasCoarsePointer =
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia('(pointer: coarse)').matches
      : false;
  const hasTouch = typeof window !== 'undefined' && ('ontouchstart' in window || maxTouchPoints > 0);
  if (hasCoarsePointer && hasTouch) return true;

  return /Android|iP(hone|od|ad)|IEMobile|Opera Mini|Mobile|Tablet/i.test(userAgent);
};
